var exports = {
  "w": "ShareButton__SSHvG-",
  "E": "Text__dlgXbh",
};

module.exports = exports;
